<!--  -->
<template>
  <div class="ShopNumber" style="width: 100%;">
    <div class="shop-select-wrapper">
      <el-select
        v-model="ShopIds"
        placeholder="请选择"
        collapse-tags
        multiple
        style="width: 100%;"
        :clearable="true"
        class="custom-collapse-select"
      >
      <div class="checkBox" style="max-height: 180px; overflow-y: auto">
        <el-option
          v-for="item in cities"
          :key="item.value"
          :value="item.value"
          :label="item.label"
        >
          <el-checkbox
            @change="changeSelect(item.value)"
            :value="ShopIds.includes(item.value)"
          ></el-checkbox>

          <span class="spanthree">{{ item.source }}</span>

          <span>
            {{ item.label }}
          </span>
          <!-- <el-checkbox :value="ShopIds.includes(item.value)" :label="item.label"> -->
        </el-option>
      </div>

      <div class="selBottom">
        <div class="selBottomOne">
          <el-button size="small" @click="AllShopId">全选</el-button>
          <el-button size="small" @click="fanXuan">反选</el-button>
          <el-button size="small" @click="clearSelect">清空多选</el-button>
        </div>
        <div class="selBottomTwo">
          <el-button type="text" icon="el-icon-refresh" @click="listInit"
            >刷新</el-button
          >
        </div>
      </div>
    </el-select>
      <!-- 自定义显示总数量 -->
      <span v-if="ShopIds.length > 1" class="total-count-tag">共 {{ ShopIds.length }} 个</span>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import { listOne } from "@/api/option.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  props: {
    Prompt: {
      type: Number,
      default: 0,
    },
  },
  components: {},
  data() {
    //这里存放数据
    return {
      cities: [
      
      ],

      ShopIds: [],
      loading: false,
      listEndShop: [],
      dialogVisibleShope: false,
      paramsShop: {
        pageSize: 500,
        pageNum: 1,
        orderByColumn: "",
        isAsc: "asc",
        source: "tb",
      },
    };
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    ShopIds(newVal, oldVal) {
      // 验证至少选择一个店铺
      this.validateShopSelection(newVal);

      // 
      // 必须含选中一个店铺
      if (newVal.length === 0) {
        this.ShopIds[0] = this.cities[0].value;
      }
      // 保存到本地存储
      localStorage.setItem("selectedShopIds", JSON.stringify(newVal));
      // 通知父组件最新的店铺选择
      this.$emit("shop-change", newVal);
      // this.$emit("child-event", newVal); // 触发自定义事件
    },
  },
  //方法集合
  methods: {
    // 验证店铺选择
    validateShopSelection(selectedShops) {
      if (!selectedShops || selectedShops.length === 0) {
        this.$message({
          type: "warning",
          message: "请至少选择一个店铺",
          duration: 2000,
        });
        return false;
      }
      return true;
    },
    // 处理单个店铺选择变化
    changeSelect(shopValue) {
      const index = this.ShopIds.indexOf(shopValue);
      if (index > -1) {
        // 如果要取消选择，检查是否至少保留一个店铺
        if (this.ShopIds.length === 1) {
          this.$message({
            type: "warning",
            message: "请至少保留一个店铺",
            duration: 2000,
          });
          return;
        }
        this.ShopIds.splice(index, 1);
        // 如果取消后没有选中任何店铺，自动选择第一个店铺
        if (this.ShopIds.length === 0) {
          this.$message({
            type: "warning",
            message: "已自动选择第一个店铺",
            duration: 2000,
          });
        }
      } else {
        // 添加选择
        this.ShopIds.push(shopValue);
      }
    },
    calculateDaysDifference(startTime, endTime) {
      let startDate = new Date(startTime);
      let endDate = new Date(endTime);
      // 计算时间戳差值（以毫秒为单位）
      let timeDifference = endDate - startDate;
      // 将毫秒转换为天数
      let daysDifference = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
      return daysDifference;
    },

    fanXuan() {
      let data = [];
      this.cities.forEach((ee) => {
        data.push(ee.value);
      });
      this.ShopIds = data.filter((item) => !this.ShopIds.includes(item));
      // 保存到本地存储
      localStorage.setItem("selectedShopIds", JSON.stringify(this.ShopIds));
    },
    //开始拿店铺的数据
    async initShop() {
      try {
        let res = await listOne(this.paramsShop);
        if (res.data.code !== 200) {
          // 如果是 401 错误，不处理，让 request.js 统一处理
          if (res.data.code === 401) {
            return;
          }
          return;
        }

        let tableDataList = JSON.parse(JSON.stringify(res.data.rows));

        if (res.data.total !== 0) {
          tableDataList = tableDataList.map((item) => ({
            ...item,

            dataCha: this.calculateDaysDifference(
              item.authStartTime,
              item.authEndTime
            ),
          }));
        }

        this.loading = false;
        localStorage.setItem("storeList", JSON.stringify(tableDataList));

        let ShopNumbers = JSON.parse(localStorage.getItem("storeList") || "[]");

        // 过滤过期店铺
        this.listEndShop = ShopNumbers.filter(
          (item) => item.dataCha < 0 || item.shopState == 4
        );
        if (this.listEndShop.length > 0) {
          this.dialogVisibleShope = true;
        }

        if (ShopNumbers.length === 0) {
          this.$notify({
            title: "提示",
            message: "暂未绑定店铺",
          });
          return;
        }

        // 先过滤掉 1688 店铺，只保留销售店铺（source === "tb"）
        let salesShopNumbers = ShopNumbers.filter((item) => {
          return item.source === "tb";
        });

        // 检查是否有销售店铺
        if (salesShopNumbers.length === 0) {
          this.$notify({
            title: "提示",
            message: "暂未绑定销售店铺",
          });
          return;
        }

        // 处理店铺ID - 优先从本地存储读取已选择的店铺ID
        let storedSelectedShopIds = JSON.parse(
          localStorage.getItem("selectedShopIds") || "[]"
        );
        let storedShopId = Number(localStorage.getItem("shopId") || 0);

        if (storedSelectedShopIds.length > 0) {
          // 验证存储的店铺ID是否仍然有效，且必须是销售店铺（source === "tb"）
          const validShopIds = storedSelectedShopIds.filter((id) =>
            salesShopNumbers.some((shop) => shop.shopNumber === id)
          );
          this.ShopIds =
            validShopIds.length > 0
              ? validShopIds
              : [salesShopNumbers[0].shopNumber];
        } else if (storedShopId && storedShopId !== 0) {
          // 验证存储的店铺ID是否是销售店铺
          const isValidSalesShop = salesShopNumbers.some(
            (shop) => shop.shopNumber === storedShopId
          );
          this.ShopIds = isValidSalesShop
            ? [storedShopId]
            : [salesShopNumbers[0].shopNumber];
        } else {
          // 默认选择第一个销售店铺
          this.ShopIds = [salesShopNumbers[0].shopNumber];
        }

        // 保存到本地存储
        localStorage.setItem("selectedShopIds", JSON.stringify(this.ShopIds));

        // 使用过滤后的销售店铺列表
        ShopNumbers = salesShopNumbers;
        this.cities = ShopNumbers.map((item) => ({
          value: item.shopNumber,
          label: item.shortTitle,
          source:
            item.source == "tb"
              ? "淘"
              : item.source == "ks"
              ? "快"
              : item.source == "pdd"
              ? "拼"
              : item.source == "jd"
              ? "京"
              : item.source == "dy"
              ? "抖"
              : item.source == "1688"
              ? "88"
              : "",
          checked: false,
        }));
      } catch (error) {
        console.error("初始化店铺失败:", error);
        this.loading = false;
        this.$notify({
          title: "错误",
          // message: "初始化店铺信息失败",
          type: "error",
        });
      }
    },
    AllShopId() {
      this.ShopIds = [];
      this.cities.forEach((item) => {
        this.ShopIds.push(item.value);
      });
    },
    //取消选中
    clearSelect() {
      // 检查是否至少保留一个店铺
      if (this.ShopIds.length > 1) {
        this.ShopIds = [];
      } else if (this.ShopIds.length === 1) {
        this.$message({
          type: "warning",
          message: "请至少保留一个店铺",
          duration: 2000,
        });
      } else {
        this.$message({
          type: "warning",
          message: "请至少选择一个店铺",
          duration: 2000,
        });
      }
    },
    // 刷新店铺查询
    listInitOne() {
      this.skuId = "";
      this.loadingGoods = true;
 
      queryGoodsName(this.goodsBody).then((res) => {
        this.loadingGoods = false;
        if (res.data.code == 200) {
          this.goodsNameList = res.data.data.map((item) => {
            return {
              ...item,
              isChecked: false,
            };
          });

          localStorage.setItem(
            "goodsNameList",
            JSON.stringify(this.goodsNameList)
          );
        } else {
        }
      });
    },
    //刷新店铺列表
    listInit() {
      this.initShop();
      // this.$message({
      //   type: "warning",
      //   message: "已是最新列表",
      // });
    },
  },
  beforeCreate() {}, //生命周期 - 创建之前
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.initShop();
  },
  beforeMount() {}, //生命周期 - 挂载之前
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，激活
  deactivated() {}, //如果页面有keep-alive缓存功能，非激活
};
</script>
<style lang="less" scoped>
.selBottom {
  font-size: 10px;
  margin-top: 10px;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  box-sizing: border-box;
  align-items: center;
  padding: 0px 5px;

  .selBottomOne {
    .el-button--small,
    .el-button--small.is-round {
      padding: 3px 5px;
      color: #b7b2bc;
      // background-color: pink !important;
    }
  }

  .selBottomTwo {
    font-size: 10px;
    color: #b7b2bc;
    font-size: 12px;
  }
}

.spanthree {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 12px;
  font-family: Arial, sans-serif;
  /* 避免字体偏移 */
  color: white;
  background-color: #85878a;
  border-radius: 50%;
  margin-left: 5px;
  line-height: 1;
  /* 重置行高 */
  padding: 0;
  /* 清除默认 padding */
}

/* 自定义多选样式 - 隐藏默认折叠标签，保留第一个标签 */
.custom-collapse-select {
  .el-tag--collapse {
    display: none !important;
  }

  .el-tag {
    background-color: #ecf5ff;
    border-color: #b3d8ff;
    color: #409eff;
    padding: 2px 8px;
    font-size: 12px;
    border-radius: 4px;
    margin-right: 4px;
  }
}

/* 店铺选择包装器 */
.shop-select-wrapper {
  position: relative;
  width: 100%;
}

/* 自定义总数量标签 */
.total-count-tag {
  position: absolute;
  right: 38px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  color: #606266;
  // padding: 2px 8px;
  // background-color: #f5f7fa;
  border-radius: 4px;
  pointer-events: none;
  font-weight: 500;
}
</style>